import "./index.scss";
import {useTranslation} from "react-i18next";

type Props = {
  headers: string[];
};

const TableHeader = ({headers}: Props) => {
  const { t } = useTranslation();

  return (
    <thead id="custom-table-header">
      <tr>
        {headers.map((header: string, index: number) => (
          <td key={`th-${index}`}>{t(header)}</td>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
